import { render, staticRenderFns } from "./MagnetismDetailDialog.vue?vue&type=template&id=31f860ea&scoped=true&"
import script from "./MagnetismDetailDialog.vue?vue&type=script&lang=js&"
export * from "./MagnetismDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./MagnetismDetailDialog.vue?vue&type=style&index=0&id=31f860ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f860ea",
  null
  
)

export default component.exports